// extracted by mini-css-extract-plugin
export default {"overlay":"loader_overlay__qT+2I","loader":"loader_loader__WaCNR","l1":"loader_l1__JekHa"};